import { render, staticRenderFns } from "./BasicInput.vue?vue&type=template&id=9600c7be&scoped=true&"
import script from "./BasicInput.vue?vue&type=script&lang=js&"
export * from "./BasicInput.vue?vue&type=script&lang=js&"
import style0 from "./BasicInput.vue?vue&type=style&index=0&id=9600c7be&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9600c7be",
  null
  
)

export default component.exports